import { createAction } from 'redux-actions';
import moment from 'moment';
import { push } from 'react-router-redux';

import { languageMapRoute } from 'util/i18n';

export const changeLanguage = createAction('CHANGE_LANGUAGE', lan => {
	moment.locale(lan);
	document.body.setAttribute('lan', lan);
	return { lan };
});

export const changeRouteByLanguage = createAction(
	'CHANGE_ROUTE_BY_LANGUAGE',
	targetLanguage => (dispatch, getState) => {
		const {
			routing: { locationBeforeTransitions: { query, pathname } },
			i18n: { lan },
		} = getState();

		const newPathname =
			pathname !== '/'
				? pathname.replace(languageMapRoute(lan), languageMapRoute(targetLanguage))
				: `/${languageMapRoute(targetLanguage)}`;

		dispatch(push({ pathname: newPathname, query }));
	},
);



// WEBPACK FOOTER //
// ./src/actions/i18n.js